document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '[data-reveal-block]' ).forEach( ( block ) => {
		const trigger = block.querySelector( '.req-reveal-block__trigger' );
		const content = block.querySelector( '.req-reveal-block__content' );

		if ( ! trigger || ! content ) {
			return;
		}

		trigger.addEventListener( 'click', () => {
			const isOpen = trigger.getAttribute( 'aria-expanded' ) === 'true';

			if ( isOpen ) {
				return;
			}

			content.hidden = false;
			content.style.height = '0px';

			// Force layout before transitioning to the measured content height.
			content.getBoundingClientRect();

			const contentHeight = `${ content.scrollHeight }px`;

			trigger.setAttribute( 'aria-expanded', 'true' );
			block.classList.add( 'is-open' );
			content.style.height = contentHeight;

			content.addEventListener(
				'transitionend',
				( event ) => {
					if ( event.propertyName !== 'height' ) {
						return;
					}

					content.style.height = 'auto';
				},
				{ once: true }
			);
		} );
	} );
} );
